import api from './api';

const config = {
    headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Credentials': false
    }
}

export const getOptionAllAprovacoes = async () => {
    let rst = false;
    try {
        const response = await api.get(`Aprovacoes/check-all-aprovacoes`, config);
        rst = response?.data?.data ?? false;
    } catch (err) {
        return false;
    }
    return rst;
}